const SMALL_MOBILE_SCREEN_SIZE = 360;
const MOBILE_SCREEN_SIZE = 600;
const TABLET_SCREEN_SIZE = 1050;
const DIALOG_SCREEN_SIZE = 625;
const SMALL_TABLET_SCREEN_SIZE = 768;
const DESKTOP_SCREEN_SIZE = 1680;
const XL_DESKTOP_SCREEN_SIZE = 1920;
const DESKTOP_HORIZONTAL_PADDING = 140;
const MOBILE_HORIZONTAL_PADDING = 20;
const TABLET_HORIZONTAL_PADDING = 40;
const WIDGET_SPACE = 50;
const WIDGET_SPACE_HALF = WIDGET_SPACE / 2;
const WIDGET_MEDIA_BORDER_RADIUS = 5;
const DEFAULT_LINK_ID = "#";
var BRANDCLUB_RETAILERS = /* @__PURE__ */ ((BRANDCLUB_RETAILERS2) => {
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Amazon"] = 1] = "Amazon";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Walmart"] = 2] = "Walmart";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["BestBuy"] = 3] = "BestBuy";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Target"] = 4] = "Target";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Costco"] = 9] = "Costco";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Chewy"] = 18] = "Chewy";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Kroger"] = 48] = "Kroger";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Sephora"] = 50] = "Sephora";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Safeway"] = 92] = "Safeway";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Qfc"] = 93] = "Qfc";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Albertsons"] = 94] = "Albertsons";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["FredMeyer"] = 127] = "FredMeyer";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["Ralphs"] = 128] = "Ralphs";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["KrogerFamily"] = 129] = "KrogerFamily";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["AlbertsonsFamily"] = 170] = "AlbertsonsFamily";
  BRANDCLUB_RETAILERS2[BRANDCLUB_RETAILERS2["HomeDepot"] = 6] = "HomeDepot";
  return BRANDCLUB_RETAILERS2;
})(BRANDCLUB_RETAILERS || {});
const WIDGET_PAIR_PRODUCT_PADDING = 50;
const PLACEHOLDER_GREEN_IMAGE = {
  "1X1": "https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_1x1.png"
};
const BRANDCLUB_BRAND_ID = 5e4;
const BRANDCLUB_BRAND_NAME = "BrandClub";
const UNIVERSAL_STORE_SITE = "https://brandclub.com";
export {
  BRANDCLUB_BRAND_ID,
  BRANDCLUB_BRAND_NAME,
  BRANDCLUB_RETAILERS,
  DEFAULT_LINK_ID,
  DESKTOP_HORIZONTAL_PADDING,
  DESKTOP_SCREEN_SIZE,
  DIALOG_SCREEN_SIZE,
  MOBILE_HORIZONTAL_PADDING,
  MOBILE_SCREEN_SIZE,
  PLACEHOLDER_GREEN_IMAGE,
  SMALL_MOBILE_SCREEN_SIZE,
  SMALL_TABLET_SCREEN_SIZE,
  TABLET_HORIZONTAL_PADDING,
  TABLET_SCREEN_SIZE,
  UNIVERSAL_STORE_SITE,
  WIDGET_MEDIA_BORDER_RADIUS,
  WIDGET_PAIR_PRODUCT_PADDING,
  WIDGET_SPACE,
  WIDGET_SPACE_HALF,
  XL_DESKTOP_SCREEN_SIZE
};
//# sourceMappingURL=Constants.js.map
